<template>
  <div class="box is-radiusless">
    <b-columns is-multiline>
      <b-column class="is-full">
        <b-columns is-multiline>
          <b-column class="is-paddingless is-full">
            <h3 class="category-heading is-size-4">{{ name }}</h3>
          </b-column>
          <b-column class="is-paddingless">
            <material-card
              v-for="(item, idx) in items"
              :key="idx"
              :title="item.title_in_portal"
              :image-url="item.thumbnail_in_portal"
              :resource-type="item.resourceType"
              :resource-id="item.id"
            />
          </b-column>
        </b-columns>
      </b-column>
    </b-columns>
  </div>
</template>

<script>
import MaterialCard from './MaterialCard'

export default {
  components: {
    MaterialCard
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.category-heading {
  margin-left: 10px;
}
</style>
